function PageNumber($, totalPageNumber) {
  var me = this;

  me.changed = function (currentPage) {
    // console.log(currentPage);
    $(".pageNumber .currentPageNumber").html(currentPage);
    $(".c-stepper__item").removeClass("active");
    $(".c-stepper__item:nth-child(" + currentPage + ")").addClass("active");
  };

  me.onReady = function (totalPageNumber) {
    $(".totalPageNumber").html(totalPageNumber);
  };
  me.onReady(totalPageNumber);
}
